module.exports = __webpack_public_path__ + "img/trud_legal.bf7914d2.jpg";